import type { CustomCollectionsStepAssets, CustomFieldSection } from "../types";

/** Type guard: true for inline `{ section }` markers in a custom step's
 *  `customFields` array (vs field configs). */
export default function isCustomFieldSection(
  entry: NonNullable<CustomCollectionsStepAssets["customFields"]>[number]
): entry is CustomFieldSection {
  return (
    typeof (entry as CustomFieldSection).section === "string" &&
    !("fieldKey" in entry)
  );
}
